<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="title"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="900px"
    >
      <div class="form-box">
        <el-form
          label-width="160px"
          style="width: 100%"
          :model="formData"
          ref="form"
          :rules="rules"
          size="small"
        >
          <el-form-item
            :label="$t('lcd.systemParameters.hasMarketId')"
            prop="marketTemplateId"
          >
            <el-input
              v-model="formData.marketTemplateName"
              clearable
              disabled
              style="width: 100%"
            >
              <el-button @click="selectTemp(1)" slot="append" icon="el-icon-thumb"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lcd.systemParameters.noMarketId')"
            prop="noMarketTemplateId"
          >
            <el-input
              v-model="formData.noMarketTemplateName"
              disabled
              style="width: 100%"
            >
              <el-button @click="selectTemp(0)" slot="append" icon="el-icon-thumb"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('lcd.systemParameters.StartTime')"
            prop="startTime"
            required
          >
            <el-date-picker
              v-model="formData.startTime"
              type="datetime"
              default-time="20:00:00"
              style="width:100%"
            >
            </el-date-picker>
          </el-form-item>

          <!-- 保存按钮 -->
          <div class="form-btn-section">
            <el-button color="#28C76F" size="small" @click="handleClose">
              {{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="onSubmit"
              >{{ $t("button.Save") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
    <SelectTemp ref="selectTempRef" @getSelectTemp="getSelectTemp"></SelectTemp>
  </div>
</template>
<script>
import SelectTemp from './selectTemp.vue'
import {
  autoTempOperation,
  delAutoTempOperation,
  getAutoTempList,
} from "@/libs/api/lcd";

let loading;

export default {
  name: "AddAutoTemplate",
  components: {SelectTemp},
  props: {},
  data() {
    return {
      title: this.$t("lcd.systemParameters.autoLCD"),
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
      initFormData: {
        marketTemplateId: "", // 带营销位的模版ID
        marketTemplateName: "", // 带营销位模板Name
        noMarketTemplateId: "", // 不带营销位的模版ID
        noMarketTemplateName: "", // 不带营销位的模版Name
        startTime: "", // 任务开始时间
      },
      formData: {
        marketTemplateId: "", // 带营销位的模版ID
        marketTemplateName: "", // 带营销位模板Name
        noMarketTemplateId: "", // 不带营销位的模版ID
        noMarketTemplateName: "", // 不带营销位的模版Name
        startTime: "", // 任务开始时间
      },
      rules: {
        marketTemplateId: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
        noMarketTemplateId: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
      },
      hasMarket: 0,
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },

    // 表单提交
    onSubmit() {
      loading = this.$loading({
        text: "loading...",
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单校验通过");
          this.createAutoTemplate();
        } else {
          loading.close();
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 请求--- 创建模板自动运营
    async createAutoTemplate() {
      let params = {
        ...this.formData,
      };
      let res = null;
      try {
        res = await autoTempOperation(params);
        let response = res.data;
        if (response.state) {
          let message = this.$t("commonMessage.CreateSucess");
          this.$message({
            message: message,
            type: "success",
          });
          loading.close();
          this.dialogVisible = false
        } else {
          loading.close();
          this.$message.error(response.message);
        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
      }
    },

    selectTemp(val){
      console.log(122333,val)
      this.hasMarket = val
      this.$refs.selectTempRef.open()
    },
    getSelectTemp(row){
      console.log(row)
      if(this.hasMarket == 0){
        this.formData.noMarketTemplateId = row.templateId
        this.formData.noMarketTemplateName = row.templateName
      } else {
        this.formData.marketTemplateId = row.templateId
        this.formData.marketTemplateName = row.templateName
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.create-image {
  // 重置样式
  ::v-deep .el-dialog {
    margin-top: 15vh !important;
  }
}
.systemManage-create.create-image {
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 60px;
  }
  .el-select,
  .el-input--small {
    width: 82%;
    margin-right: 10px;
  }
  ::v-deep .el-tag {
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    padding-right: 30px;
    // word-wrap: break-word;
    // word-break: break-all;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.select-group {
  .table-icon {
    padding: 6px;
    cursor: pointer;
    font-size: 18px;
    color: #000;
  }
}

.resolutionInput {
  margin-right: 12px;
  ::v-deep .el-input__inner {
    border: none !important;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
  }
}
</style>